// extracted by mini-css-extract-plugin
export var aboutHeader = "accomplishments-module--about-header--edd64";
export var accomplishment = "accomplishments-module--accomplishment--dc0e6";
export var border = "accomplishments-module--border--6d393";
export var btn = "accomplishments-module--btn--2f994";
export var btnAbsolute = "accomplishments-module--btnAbsolute--7315f";
export var center = "accomplishments-module--center--82bfe";
export var gatsbyImage = "accomplishments-module--gatsby-image--e9ced";
export var headerBorder = "accomplishments-module--header-border--c96b1";
export var headerImg = "accomplishments-module--header-img--03057";
export var heading = "accomplishments-module--heading--4fa99";
export var headingSubtitle = "accomplishments-module--heading-subtitle--65eea";
export var headingTitle = "accomplishments-module--heading-title--1ca12";
export var imageLinks = "accomplishments-module--image-links--2e6fa";
export var imgResponsive = "accomplishments-module--img-responsive--0e1f8";
export var inlineBlock = "accomplishments-module--inline-block--8cdcb";
export var inner = "accomplishments-module--inner--1b28d";
export var socialLinks = "accomplishments-module--social-links--c685f";
export var socialRight = "accomplishments-module--social-right--bab69";
export var socialSectionTriangle = "accomplishments-module--socialSectionTriangle--de3ea";
export var teamSection = "accomplishments-module--teamSection--54859";
export var textDark = "accomplishments-module--text-dark--ee170";
export var whatWeDo = "accomplishments-module--whatWeDo--3d006";